const constants = {
  API_CALL_TYPE: {
    POST: 'post',
    GET: 'get'
  },
  USER_DETAILS_KEY: 'user',
  USER_AUTH_KEY: 'auth',
  SELL_CURRENT_INVOICE_KEY: 'current_invoice',
  SELL_INVOICE_QUEUE_KEY: 'invoice_queue',
  X_API_KEY: "X-API-KEY",
  STOCK_DATE_RANGE: "stock_date_range",
};

export default constants;

export var ROOT_SYNC_SCOPE = false;
